module.exports = __webpack_public_path__ + "static/hero-header-4f3943d9f00496e59fac49aeff00bf2a.png";